import React, { useCallback, useState } from 'react';
import { Typography } from 'ui-kit';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import './styles.scss';
import SecondConfirmModalMassDeleteProduct from 'components/SecondConfirmMassDeleteProduct';

const ConfirmModalMassDeleteProduct = ({
  isOpen,
  onConfirm,
  onCancel,
}: {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
  const handleConfirm = useCallback(() => {
    setIsSecondModalOpen(false);
    onConfirm();
  }, [onConfirm]);

  return (
    <>
      <ConfirmModal
        className="ConfirmPropagateModal"
        visible={isOpen}
        onConfirm={() => setIsSecondModalOpen(true)}
        onCancel={onCancel}
        confirmText="Yes"
        cancelText="No"
        confirmBtnType="error"
        destroyOnClose
      >
        <Typography className="ConfirmPropagateModal_title" variant="h6">
          Delete Tile from All Stores
        </Typography>
        <p>
          This will delete ALL tiles for this product that were created together as a single set,
          even if the name of the tile has been modified.
        </p>
      </ConfirmModal>
      <SecondConfirmModalMassDeleteProduct
        isOpen={isSecondModalOpen}
        onConfirm={handleConfirm}
        onCancel={() => setIsSecondModalOpen(false)}
      />
    </>
  );
};

export default ConfirmModalMassDeleteProduct;
